import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/')({
  beforeLoad: ({ context }) => {
    const { user, isAuthenticated } = context.authenticationContext;
    const { healthCenterConfig } = context.healthCenterContext;
    const { app } = context.userAppContext;

    if (isAuthenticated) {
      if (app === 'cleaning-agent') {
        throw redirect({ to: '/environmental-cleaning' });
      }
      if (user?.role === 'PORTER') {
        if (!healthCenterConfig?.id) {
          throw redirect({ to: '/health-center-link' });
        }
        throw redirect({ to: '/patient-transport' });
      }
      if (user?.role === 'BED_MANAGER') {
        throw redirect({ to: '/bed-management' });
      }
    }

    if (!app) {
      throw redirect({ to: '/app-select' });
    }

    if (app === 'porter') {
      throw redirect({ to: '/health-center-link' });
    }
    throw redirect({ to: '/login' });
  },
});
